/**
 * Tipos para el módulo Llamadas (cola, estado del agente).
 */

export type CallCenterAgentStatus = 'available' | 'on_call' | 'break' | 'wrap_up';

/** Disposiciones post-llamada (After-Call Work). */
export type CallDisposition =
  | 'venta_confirmada'
  | 'interesado'
  | 'no_contesta'
  | 'buzon_voz'
  | 'numero_equivocado'
  | 'rechazo_pedido'
  | 'ocupado'
  | 'callback'
  | 'otro';

export const CALL_DISPOSITION_LABELS: Record<CallDisposition, string> = {
  venta_confirmada: 'Venta confirmada',
  interesado: 'Interesado',
  no_contesta: 'No contesta',
  buzon_voz: 'Buzón de voz',
  numero_equivocado: 'Número equivocado',
  rechazo_pedido: 'Rechazó pedido',
  ocupado: 'Ocupado',
  callback: 'Rellamar después',
  otro: 'Otro',
};

export type CallCenterQueueTaskStatus =
  | 'pending'
  | 'calling'
  | 'assigned'
  | 'completed'
  | 'cancelled';

export interface CallCenterAgentStatusRow {
  id: string;
  tenant_id: string;
  user_id: string;
  status: CallCenterAgentStatus;
  updated_at: string;
}

export interface CallCenterQueueTaskRow {
  id: string;
  tenant_id: string;
  lead_id: string;
  campaign_id: string | null;
  status: CallCenterQueueTaskStatus;
  assigned_agent_id: string | null;
  created_at: string;
  updated_at: string;
}

/** Fase J: Campañas de llamadas */
export type CallCenterCampaignStatus = 'draft' | 'active' | 'paused' | 'completed';

export interface CallCenterCampaignRow {
  id: string;
  tenant_id: string;
  name: string;
  description: string | null;
  status: CallCenterCampaignStatus;
  created_at: string;
  updated_at: string;
}

export interface CallCenterQueueTaskWithLead extends CallCenterQueueTaskRow {
  lead?: { id: string; name: string | null; phone: string | null } | null;
}

/** Fase H: Centralita — extensión por asesor */
export interface CallCenterAgentExtensionRow {
  id: string;
  tenant_id: string;
  user_id: string;
  extension: string;
  internal_number: string | null;
  created_at: string;
  updated_at: string;
}
